import { Link } from 'react-router-dom';
import { ArrowDownToLine, ArrowUpFromLine, QrCode, List } from 'lucide-react';
import { clsx } from 'clsx';

export function QuickActions() {
  const actions = [
    {
      label: 'Cash In',
      description: 'Recibir efectivo',
      icon: ArrowDownToLine,
      href: '/cash-in',
      color: 'bg-green-600 hover:bg-green-700',
      iconBg: 'bg-green-100',
      iconColor: 'text-green-600',
    },
    {
      label: 'Cash Out',
      description: 'Entregar efectivo',
      icon: ArrowUpFromLine,
      href: '/cash-out',
      color: 'bg-blue-600 hover:bg-blue-700',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
    },
    {
      label: 'Escanear QR',
      description: 'QR del usuario',
      icon: QrCode,
      href: '/scan',
      color: 'bg-purple-600 hover:bg-purple-700',
      iconBg: 'bg-purple-100',
      iconColor: 'text-purple-600',
    },
    {
      label: 'Historial',
      description: 'Ver transacciones',
      icon: List,
      href: '/transactions',
      color: 'bg-gray-600 hover:bg-gray-700',
      iconBg: 'bg-gray-100',
      iconColor: 'text-gray-600',
    },
  ];

  return (
    <div className="bg-white rounded-lg shadow border border-gray-200">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">Acciones Rápidas</h2>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {actions.map((action) => {
            const Icon = action.icon;
            return (
              <Link
                key={action.label}
                to={action.href}
                className="flex flex-col items-center gap-3 p-4 rounded-lg border-2 border-gray-200 hover:border-primary-500 hover:shadow-md transition-all group"
              >
                <div className={clsx('p-3 rounded-full', action.iconBg)}>
                  <Icon className={clsx('w-6 h-6', action.iconColor)} />
                </div>
                <div className="text-center">
                  <p className="font-semibold text-gray-900 group-hover:text-primary-600">
                    {action.label}
                  </p>
                  <p className="text-xs text-gray-500 mt-1">{action.description}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}


export default QuickActions;
